import { observer } from "mobx-react-lite";
import { LinkIcon } from "lucide-react";

import { CombineColumnsConfiguration } from "@/types/evaluate";
import { BlockProps } from "@/components/PowerBlock/Block";
import { withBlockStore } from "@/components/PowerBlock/Block/block-store";
import { createEmptySources } from "@/components/PowerBlock/Block/hooks";
import { useIsReadonly } from "@/components/PowerBlock/Block/readonly-context";
import SectionGroup from "@/components/PowerBlock/Block/SectionGroup";
import { ArraySourceSelector } from "@/components/PowerBlock/Block/SourceSelectors";
import ValidatedField from "@/components/PowerBlock/Block/ValidatedField";
import { createBlockSchema } from "@/components/PowerBlock/Block/validation/schemaBuilder";

const validationSchema = createBlockSchema<CombineColumnsConfiguration>()
  .requireName()
  .requireSources(2)
  .build();

const CombineResultsBlockCore = observer(
  ({
    sources: availableSources = createEmptySources(),
  }: Omit<BlockProps<CombineColumnsConfiguration>, "DefaultFields">) => {
    const isReadonly = useIsReadonly();

    return (
      <SectionGroup
        title="Data Sources"
        description="Select sources to combine into a single structured output"
        icon={<LinkIcon className="h-4 w-4" />}
      >
        <ValidatedField path="configuration.sources" variant="sources" showValidationIcons={false}>
          <ArraySourceSelector sources={availableSources} min={2} disabled={isReadonly} />
        </ValidatedField>
      </SectionGroup>
    );
  },
);

export default withBlockStore<CombineColumnsConfiguration>(CombineResultsBlockCore, {
  validationSchema,
});
